export const getAudioDuration = (file, isUrl) => {
  return new Promise((resolve, reject) => {
    let url;
    if (isUrl) {
      url = file;
    } else {
      url = URL.createObjectURL(file);
    }
    const audio = new Audio(url);
    audio.onloadedmetadata = () => {
      resolve(audio.duration);
    };
    audio.onerror = error => {
      reject(error);
    };
  });
};
